import { Question } from '../domain/types';

export const SCOPING_QUESTIONS: Question[] = [
  {
    id: 'product_type',
    text: 'questions.product_type.text',
    type: 'radio',
    options: [
      'machinery',
      'partly_completed_machinery',
      'safety_component',
      'electrical_equipment',
      'pressure_equipment',
      'lift',
      'medical_device',
      'construction_product',
      'personal_protective_equipment',
      'toy',
      'radio_equipment',
      'other',
    ],
    required: true,
    helpText: 'questions.product_type.helpText',
  },
  {
    id: 'uses_electricity',
    text: 'questions.uses_electricity.text',
    type: 'radio',
    options: ['yes', 'no'],
    required: true,
  },
  {
    id: 'voltage_level',
    text: 'questions.voltage_level.text',
    type: 'select',
    options: ['<50V', '50-1000V', '>1000V'],
    required: true,
    dependsOn: 'uses_electricity',
    dependsOnValue: 'yes',
  },
  {
    id: 'transmits_radio_waves',
    text: 'questions.transmits_radio_waves.text',
    type: 'radio',
    options: ['yes', 'no'],
    required: true,
    helpText: 'questions.transmits_radio_waves.helpText',
  },
  {
    id: 'contains_electronic_components',
    text: 'questions.contains_electronic_components.text',
    type: 'radio',
    options: ['yes', 'no'],
    required: true,
  },
  {
    id: 'intended_for_children',
    text: 'questions.intended_for_children.text',
    type: 'radio',
    options: ['yes', 'no'],
    required: true,
    helpText: 'questions.intended_for_children.helpText',
  },
  {
    id: 'is_medical_device',
    text: 'questions.is_medical_device.text',
    type: 'radio',
    options: ['yes', 'no'],
    required: true,
  },
  {
    id: 'market_date',
    text: 'questions.market_date.text',
    type: 'date',
    required: true,
    validation: (value) => {
      const date = new Date(value);
      return !isNaN(date.getTime()) && date > new Date('2020-01-01');
    },
  },
];
